'use client';

import { HouseholdWithRelationsOrNull } from '@/prismaModels';

import { createContext, useContext } from 'react';

export const HouseholdContext = createContext<HouseholdWithRelationsOrNull>(null);

export function useHousehold(): HouseholdWithRelationsOrNull {
  return useContext(HouseholdContext);
}

export default function HouseholdProvider({
  value,
  children,
}: {
  value: HouseholdWithRelationsOrNull;
  children: React.ReactNode;
}) {
  return <HouseholdContext.Provider value={value}>{children}</HouseholdContext.Provider>;
}
